// Notes list filter types
import type { NoteStatus, PriorityLevel } from './conversation'

export interface NotesListFilters {
  assistant_id?: number[]
  status?: NoteStatus
  assigned_to?: number[]
  is_private?: boolean
  priority?: PriorityLevel
}

// Priority configuration for display
export interface PriorityConfig {
  label: string
  color: string
  bgColor: string
}

export const priorityConfig: Record<PriorityLevel, PriorityConfig> = {
  low: {
    label: 'Low',
    color: 'text-gray-600 dark:text-gray-400',
    bgColor: 'bg-gray-100 dark:bg-gray-800',
  },
  medium: {
    label: 'Medium',
    color: 'text-blue-600 dark:text-blue-400',
    bgColor: 'bg-blue-100 dark:bg-blue-800/30',
  },
  high: {
    label: 'High',
    color: 'text-orange-600 dark:text-orange-400',
    bgColor: 'bg-orange-100 dark:bg-orange-800/30',
  },
  critical: {
    label: 'Critical',
    color: 'text-red-600 dark:text-red-400',
    bgColor: 'bg-red-100 dark:bg-red-800/30',
  },
}

// Status configuration for display
export interface StatusConfig {
  label: string
  color: string
  bgColor: string
}

export const statusConfig: Record<NoteStatus, StatusConfig> = {
  none: {
    label: 'None',
    color: 'text-gray-600 dark:text-gray-400',
    bgColor: 'bg-gray-100 dark:bg-gray-800',
  },
  open: {
    label: 'Open',
    color: 'text-green-600 dark:text-green-400',
    bgColor: 'bg-green-100 dark:bg-green-800/30',
  },
  closed: {
    label: 'Closed',
    color: 'text-gray-500 dark:text-gray-500',
    bgColor: 'bg-gray-100 dark:bg-gray-800',
  },
}
